import { addText, stripHtmlFromString } from './HTMLManipulation';
export function getTargetByKey(object, key) {
  return object.find(obj => obj.key === key);
}
export function getKey(typeId) {
  switch (typeId) {
    case 12:
      return 'mention';
    case 10001:
      return 'example';
    default:
      return undefined;
  }
}
export function getContextText(context, typeId) {
  const key = getKey(typeId);
  const targetObject = key ? getTargetByKey(context, key) : undefined;
  if (!(targetObject && targetObject.value)) {
    return null;
  }
  let contextText = targetObject.value;
  contextText = addText('@', contextText, 'span', 'data-at-mention');
  return stripHtmlFromString(contextText);
}